import { registerSW } from 'virtual:pwa-register';

const SKIP_WAITING = { type: 'SKIP_WAITING' } as const;
const WAIT_FOR_WORKER_MS = 10_000;

let updateServiceWorker: ((reloadPage?: boolean) => Promise<void>) | undefined;

export const registerPwa = () => {
  updateServiceWorker = registerSW({
    immediate: true,
    onNeedRefresh() {
      // Баннер показывает AppUpdateBanner через versionCheck
    },
    onOfflineReady() {
      console.info('[PWA] Приложение готово к работе офлайн');
    },
  });
};

async function waitForWaitingWorker(
  registration: ServiceWorkerRegistration,
  timeoutMs: number,
): Promise<ServiceWorker | null> {
  if (registration.waiting) {
    return registration.waiting;
  }

  const installing = registration.installing;
  if (!installing) {
    return null;
  }

  return new Promise((resolve) => {
    let settled = false;

    const onStateChange = () => {
      if (registration.waiting) {
        finish(registration.waiting);
        return;
      }

      if (installing.state === 'redundant') {
        finish(null);
      }
    };

    const finish = (worker: ServiceWorker | null) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeoutId);
      installing.removeEventListener('statechange', onStateChange);
      resolve(worker);
    };

    const timeoutId = window.setTimeout(() => finish(null), timeoutMs);
    installing.addEventListener('statechange', onStateChange);
  });
}

export function prefetchAppUpdate(): void {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  void navigator.serviceWorker.getRegistration().then((registration) => registration?.update());
}

export async function applyAppUpdate(): Promise<void> {
  if (!('serviceWorker' in navigator)) {
    window.location.reload();
    return;
  }

  const registration = await navigator.serviceWorker.getRegistration();
  if (!registration) {
    window.location.reload();
    return;
  }

  const reloadPromise = new Promise<void>((resolve) => {
    navigator.serviceWorker.addEventListener(
      'controllerchange',
      () => {
        window.location.reload();
        resolve();
      },
      { once: true },
    );
  });

  await registration.update();

  const waiting = await waitForWaitingWorker(registration, WAIT_FOR_WORKER_MS);

  if (waiting) {
    if (updateServiceWorker) {
      await updateServiceWorker(true);
    } else {
      waiting.postMessage(SKIP_WAITING);
    }
    await Promise.race([
      reloadPromise,
      new Promise<void>((resolve) => window.setTimeout(resolve, 3_000)),
    ]);
    window.location.reload();
    return;
  }

  window.location.reload();
}
